import { TransportMode } from '../../../../common/constants';
import { DeviationType, FreightMode, LatestNotification, MonitoringStatus } from '../../..';
import { TransportationTrackingDates, TransportationTrackingParty } from '../../../../ui-kit';

//moved from legacy transport order
export interface TransportOrderOverview {
  arrivalTimeDeviation: number;
  departureTimeDeviation: number;
  dates: TransportationTrackingDates;
  delayed: boolean;
  freightMode: FreightMode;
  inTime: DeviationType;
  transportModes: TransportMode[];
  incoterms: string;
  delivery: TransportationTrackingParty;
  pickup: TransportationTrackingParty;
  status: MonitoringStatus;
  statusCode: string;
  statusDescription: string;
  transportOrderNumber: string;
  latestNotification: LatestNotification;
  deliveryNoteNumbers: string[];
  invoiceNumbers: string;
  houseAirWaybillNumber: string;
  houseBillOfLading: string;
}
